import type { LucideIcon } from "lucide-react";

/**
 * Hidden SVG defs providing shared gradients for all GemIcon instances.
 * Render once in App.tsx.
 */
export const GemIconDefs = () => (
  <svg width="0" height="0" className="absolute" aria-hidden="true">
    <defs>
      <linearGradient id="gem-icon-grad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#6FBF40" />
        <stop offset="100%" stopColor="#40BFBF" />
      </linearGradient>
      <linearGradient id="gem-icon-fill-grad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#6FBF40" stopOpacity="0.15" />
        <stop offset="50%" stopColor="#40BFBF" stopOpacity="0.10" />
        <stop offset="100%" stopColor="#6FBF40" stopOpacity="0.05" />
      </linearGradient>
    </defs>
  </svg>
);

interface GemIconProps {
  icon: LucideIcon;
  size?: number;
  className?: string;
  /** Use filled gradient style (matching reference icon sheet) */
  filled?: boolean;
}

/**
 * Renders a Lucide icon with a lime‑to‑cyan gradient stroke and a subtle glow,
 * matching the site's GemDiamond visual signature.
 * Set `filled` for a bolder gradient-fill look inspired by the brand icon sheet.
 */
const GemIcon = ({ icon: Icon, size = 24, className = "", filled = false }: GemIconProps) => (
  <span
    className={`gem-icon-gradient inline-flex ${filled ? "gem-icon-filled" : ""} ${className}`}
    style={{ width: size, height: size }}
  >
    <Icon size={size} className="gem-icon-glow flex-shrink-0" />
  </span>
);

export default GemIcon;
